import React, {FunctionComponent} from "react";
import makeStyles from "@mui/styles/makeStyles";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export type TeamRegistrationHeaderType = {}

export const TeamRegistrationHeader: FunctionComponent<TeamRegistrationHeaderType> = ({}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <div className={classes.container}>
            <Typography variant={"h6"}>{t('createTeamLabel')}</Typography>
            <Typography variant={"body1"} className={classes.info}>{t('createTeamHelper1')}</Typography>
            <Typography variant={"body1"}>{t('createTeamHelper2')}</Typography>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        padding: "1.5rem 1rem"
    },
    info: {
        padding: "1rem 0"
    }
});